//@flow
import * as React from 'react';
import { Box, Stack, Columns, Column, Text } from '@locus-taxy/neo-ui';
import type { FpBeat } from 'common/models/internal/FpBeat';
import AllocatedEditItem from './AllocatedEditItem';
import { type TFunction } from 'react-i18next';
import { type BeatPlanEdits } from 'common/models/internal/BeatPlanEdits';

type AllocatedEditsCollapseComponentProps = {
    toggleUnallocationEditsCard: () => void,
    isExpandable: boolean,
    isExpanded: boolean,
    title: string,
    allocationEdits: Array<BeatPlanEdits>,
    beats: Array<FpBeat>,
    t: TFunction
};

export default class AllocatedEditsCollapseComponent extends React.PureComponent<AllocatedEditsCollapseComponentProps> {
    render() {
        const { allocationEdits, beats, t } = this.props;
        if (!allocationEdits.length) {
            return (
                <Box p={2} height="20px">
                    <Columns align="center" alignY="center" height="fluid">
                        <Column width="fluid">
                            <Text>
                                {t('entityManagement:fpPlanView.noEdits')}
                            </Text>
                        </Column>
                    </Columns>
                </Box>
            );
        }
        return (
            <Box>
                <Stack>
                    <Columns>
                        <Column width="1/4">
                            <Text fontSize={2} fontWeight={600}>
                                {t('entityManagement:fpPlanView.edits.beat')}
                            </Text>
                        </Column>
                        <Column width="1/4" fontSize={2} fontWeight={600}>
                            <Text>
                                {t('entityManagement:fpPlanView.edits.source')}
                            </Text>
                        </Column>
                        <Column width="1/4">
                            <Text fontSize={2} fontWeight={600}>
                                {t('entityManagement:fpPlanView.edits.target')}{' '}
                            </Text>
                        </Column>
                        <Column width="1/4">
                            <Text fontSize={2} fontWeight={600}>
                                {t(
                                    'entityManagement:fpPlanView.edits.editedOn'
                                )}
                            </Text>
                        </Column>
                    </Columns>

                    {allocationEdits.map(edit => {
                        return (
                            <AllocatedEditItem
                                beats={beats}
                                key={`${edit.edits.visitId}${edit.edits.sourceBeatId}`}
                                allocatedEdit={edit}
                            />
                        );
                    })}
                </Stack>
            </Box>
        );
    }
}
